/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/15/22
 */

import React from "react";
import {Stack, Typography} from "@mui/material";
import {Employee, VegaEvent} from "../interfaces/Global";
import ViewportEvent from "./ViewportEvent";
import {addMinutes, differenceInCalendarYears} from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAtlassian } from "@fortawesome/free-brands-svg-icons";
import {format} from "../dates-helper";

export interface EmployeeViewportEventProps {
	viewportRange: Interval
	rangeResolution: number
	intervalDuration: number
	employee: Employee
	employeeAttribute: "dateOfBirth" | "dateOfHire"
	event: Interval
	title: string
	openNewEventDialog: (day: Partial<VegaEvent>) => void
}

export default function EmployeeViewportEvent(props: EmployeeViewportEventProps) {

	return (
		<ViewportEvent
			viewportRange={props.viewportRange}
			rangeResolution={props.rangeResolution}
			normalizeTimezone={false}
			details={false}
			event={{
				title: props.title,
				typeId: "SP",
				startDatetime: new Date(props.event.start),
				endDatetime: new Date(props.event.end)
			}}
			tooltip={
				<EventTooltip
					title={props.title}
					event={props.event}
					employee={props.employee}
				/>
			}
			viewportIcon={props.employeeAttribute === "dateOfBirth" ? "🎂" :
				<Stack direction={"row"} alignItems={"center"} sx={{ color: "primary.main" }}>
					<FontAwesomeIcon icon={faAtlassian} />
					{differenceInCalendarYears(props.event.start, props.employee.dateOfHire as Date) > 0 &&
						<Stack>{differenceInCalendarYears(props.event.start, props.employee.dateOfHire as Date)}</Stack>}
				</Stack>}
			getViewportLabel={(width) => {
				return width > 80 ? props.title : "";
			}}
			sx={{
				backgroundColor: "transparent",
				zIndex: 20
			}}
			onClick={() => props.openNewEventDialog({
				startDatetime: new Date(props.event.start),
				endDatetime: addMinutes(new Date(props.event.start), props.intervalDuration),
				typeId: "WFO"
			})}
		/>
	);

}

interface EventTooltipProps {
	title: string
	event: Interval
	employee: Employee
}

function EventTooltip({ event, employee, title }: EventTooltipProps) {

	return (
		<Stack>
			<div>{employee.displayName}</div>
			<Typography>{title}</Typography>
			<Stack>{format(event.start, 'PPPP')}</Stack>
		</Stack>
	)

}